/**
 * Appends query parameters to a URL, preserving any existing query string.
 *
 * Follows the same pattern as checkout-ui's createPathWithQuery:
 * - Splits URL on '?' to preserve existing params
 * - Appends non-empty values
 * - Uses URLSearchParams.set() so duplicates are avoided
 */
export function appendQueryParams(
  url: string,
  params: Record<string, string | undefined>
): string {
  try {
    const [basePath, existingQuery] = url.split('?');
    const searchParams = new URLSearchParams(existingQuery || '');

    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value);
      }
    });

    const query = searchParams.toString();
    return query ? `${basePath}?${query}` : basePath;
  } catch {
    return url;
  }
}
